import { render, staticRenderFns } from "./BattleRoom.vue?vue&type=template&id=1481bab6&scoped=true&"
import script from "./BattleRoom.vue?vue&type=script&lang=ts&"
export * from "./BattleRoom.vue?vue&type=script&lang=ts&"
import style0 from "./BattleRoom.vue?vue&type=style&index=0&id=1481bab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481bab6",
  null
  
)

export default component.exports